const carrierLiabilityResources = {
  en: {
    carrierLiability: {
      title: "Insurance of the carrier's liability to passengers",
      calculator: 'Insurance calculator',
      'description.title': 'Description',
      'description.text1':
        'The provision of passenger transportation services requires additional security from the carrier. Voluntary insurance of civil liability of transporters from "Alatau City Garant" will help you insure numerous risks when delivering children to school or kindergarten, staff to the place of work, guests to the airport.',
      'description.text2': 'Policyholders – ',
      'description.text3':
        'legal entity or an individual engaged in entrepreneurial activity',
      'description.text4': 'Insured event – ',
      'description.text5':
        "the fact of the carrier's civil liability for compensation for damage caused to the life and (or) health of passengers during their transportation",
      'description.text6': 'The insurance benefit ',
      'description.text7':
        "is paid in the amount of direct material damage minus the amounts paid or payable to the victim under the contract (policy) compulsory insurance of the carrier's civil liability to passengers, which, in accordance with the law, was concluded (should have been concluded) by the policyholder, as well as the franchise established in the insurance contract, but not more than the insured amount or the limits of liability determined by the insurance contract",
      'description.text13': "The Insurer's liability limit per victim:",
      'description.text14': 'for damage caused to life/health:',
      'description.text14.1': 'in case of death - 1000 (one thousand) MCI;',
      'description.text14.2':
        'in case of disability of group I - 1000 (one thousand) MCI;',
      'description.text14.3':
        'in case of disability of group II - 700 (seven hundred) MCI;',
      'description.text14.4':
        'in case of disability of group III - 500 (five hundred) MCI;',
      'description.text14.5':
        'in case of temporary disability - 2 MCI for each day of disability (excluding holidays and weekends), but no more than 40 MCI; At the same time, the first 10 days of temporary disability are not covered by the Contract.',
      'description.text15':
        'for damage caused to the property of each Victim, no more than 50 MCI.',
      'description.text8': 'Insurance territory: ',
      'description.text9': 'Republic of Kazakhstan',
      'description.franchise.title': 'Deductible (unconditional):',
      'description.franchise.text1':
        "for damage caused to the passenger's property is set at 25,000 (twenty-five thousand) tenge for each and any insured event;",
      'description.franchise.text2':
        'the deductible does not apply for damage caused to the life/health of the passenger, but a special condition for making insurance payments applies (the first 10 days of temporary disability are not covered by the Contract).',
      'description.text10': 'Tariff: ',
      'description.text11': 'from 0.25%',
      'description.text12':
        'Why conclude a contract of voluntary insurance of civil liability of transporters?',
      'description.li1':
        "The contract of compulsory insurance of the carrier's liability to passengers is not concluded with persons who do not have permission from the authorized bodies for the carriage of passengers who carry it out on their own.",
      'description.li2':
        "The limit of liability for compulsory insurance of the carrier's civil liability to passengers is limited by law. Often, the amount of payments is not enough and the carrier has to pay part of the damage at its own expense.",
      'description.li3':
        'Even an experienced driver with experience can make a mistake that leads to an accident.',
    },
  },
  kz: {
    carrierLiability: {
      title: 'Тасымалдаушының жолаушылар алдындағы жауапкершілігін сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      'description.text1':
        'Жолаушыларды тасымалдау бойынша қызметтер көрсету тасымалдаушыдан қосымша қауіпсіздікті талап етеді. Балаларды мектепке немесе балабақшаға, қызметкерлерді жұмыс орнына, әуежайға қонақтарды жеткізу кезінде көптеген тәуекелдерді сақтандыруға "Alatau City Garant" тасымалдаушының азаматтық-құқықтық жауапкершілігін ерікті сақтандыру көмектеседі.',
      'description.text2': 'Сақтанушылар - ',
      'description.text3':
        'кәсіпкерлік қызметті жүзеге асырушы жеке немесе заңды тұлғалар',
      'description.text4': 'Сақтандыру жағдайы - ',
      'description.text5':
        'тасымалдаушының жолаушыларды тасымалдау кезінде олардың өміріне және (немесе) денсаулығына келтірілген зиянды өтеу жөніндегі азаматтық-құқықтық жауапкершілігінің басталу фактісі',
      'description.text6': 'Сақтандыру төлемі ',
      'description.text7':
        'сақтанушы заңға сәйкес жасасқан (жасасуға тиіс) тасымалдаушының жолаушылар алдындағы азаматтық-құқықтық жауапкершілігін міндетті сақтандыру шарты (полисі) бойынша жәбірленушіге төленген немесе төленуге жататын сомаларды, сондай-ақ сақтандыру шартында белгіленген шегерімді шегере отырып, тікелей материалдық залал мөлшерінде төленеді, бірақ сақтандыру сомасынан немесе белгілі бір сомадан аспайды жауапкершілік лимиттерін сақтандыру шартымен.',
      'description.text13':
        'Сақтандырушының бір жәбірленушіге жауапкершілік лимиті:',
      'description.text14': 'өмірге / денсаулыққа келтірілген зиян үшін:',
      'description.text14.1': 'қайтыс болған жағдайда - 1000 (бір мың) АЕК;',
      'description.text14.2':
        'I топтағы мүгедектік белгіленген жағдайда - 1000 (бір мың) АЕК;',
      'description.text14.3':
        'II топтағы мүгедектік белгіленген жағдайда - 700 (жеті жүз) АЕК;',
      'description.text14.4':
        'III топтағы мүгедектік белгіленген жағдайда - 500 (бес жүз) АЕК;',
      'description.text14.5':
        'еңбекке уақытша жарамсыздық кезінде - еңбекке жарамсыздықтың әрбір күні үшін 2 АЕК (мереке және демалыс күндерін қоспағанда), бірақ 40 АЕК-тен аспайды; бұл ретте еңбекке уақытша жарамсыздықтың алғашқы 10 күні Шартпен жабылмайды.',
      'description.text15':
        'әрбір жәбірленушінің мүлкіне келтірілген зиян үшін - 50 АЕК-тен аспайды.',
      'description.text8': 'Сақтандыру аумағы: ',
      'description.text9': 'Қазақстан Республикасы',
      'description.franchise.title': 'Франшиза (шартсыз):',
      'description.franchise.text1':
        'жолаушының мүлкіне келтірілген зиян үшін әрбір және кез келген сақтандыру жағдайы бойынша 25 000 (жиырма бес мың) теңге мөлшерінде белгіленеді;',
      'description.franchise.text2':
        'жолаушының өміріне/денсаулығына келтірілген зиян үшін франшиза қолданылмайды, бірақ сақтандыру төлемдерін жүзеге асырудың ерекше шарты қолданылады (еңбекке уақытша жарамсыздықтың алғашқы 10 күні Шартпен жабылмайды).',
      'description.text10': 'Тариф: ',
      'description.text11': '0,25% бастап',
      'description.text12':
        'Неліктен тасымалдаушының азаматтық-құқықтық жауапкершілігін ерікті сақтандыру шартын жасасу керек?',
      'description.li1':
        'Тасымалдаушының жолаушылар алдындағы жауапкершілігін міндетті сақтандыру шарты оны өз бетінше жүзеге асыратын жолаушыларды тасымалдауға уәкілетті органдардың рұқсаты жоқ адамдармен жасалмайды.',
      'description.li2':
        'Тасымалдаушының жолаушылар алдындағы азаматтық-құқықтық жауапкершілігін міндетті сақтандыру бойынша жауапкершілік лимиті заңнамамен шектелген. Көбінесе төлем сомасы жеткіліксіз және тасымалдаушы залалдың бір бөлігін өз есебінен төлеуі керек.',
      'description.li3':
        'Тіпті тәжірибесі бар тәжірибелі жүргізуші де ЖКО-ға әкелетін қателік жіберуі мүмкін.',
    },
  },
  ru: {
    carrierLiability: {
      title: 'Страхование ответственности перевозчика перед пассажирами',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      'description.text1':
        'Оказание услуг по перевозке пассажиров требует от перевозчика дополнительной безопасности. Застраховать многочисленные риски при доставке детей в школу или в детский сад, персонала к месту работы, гостей в аэропорт Вам поможет Добровольное страхование гражданско-правовой ответственности перевозчика, осуществляющего перевозку пассажиров от «Alatau City Garant».',
      'description.text2': 'Страхователи – ',
      'description.text3':
        'Юридическое или физическое лицо, осуществляющее предпринимательскую деятельность',
      'description.text4': 'Страховой случай – ',
      'description.text5':
        'факт наступления гражданско-правовой ответственности перевозчика по возмещению вреда, причиненного жизни и (или) здоровью пассажиров при их перевозке',
      'description.text6': 'Страховая выплата ',
      'description.text7':
        'оплачивается в размере прямого материального ущерба за вычетом сумм, выплаченных или подлежащих выплате потерпевшему по договору (полису) обязательного страхования гражданско-правовой ответственности перевозчика перед пассажирами, который в соответствии с законом заключил (должен был заключить) страхователь, а также установленной в договоре страхования франшизы, но не более страховой суммы или определенных договором страхования лимитов ответственности.',
      'description.text13':
        'Лимит ответственности Страховщика на одного потерпевшего:',
      'description.text14': 'за вред, причиненный жизни/здоровью:',
      'description.text14.1': 'в случае смерти - 1000 (одна тысяча) МРП;',
      'description.text14.2':
        'в случае установления инвалидности I группы - 1000 (одна тысяча) МРП;',
      'description.text14.3':
        'в случае установления инвалидности II группы - 700 (семьсот) МРП;',
      'description.text14.4':
        'в случае установления инвалидности III группы - 500 (пятьсот) МРП;',
      'description.text14.5':
        'при временной нетрудоспособности - 2 МРП за каждый день нетрудоспособности (исключая праздничные и выходные дни), но не более 40 МРП; При этом первые 10 дней временной нетрудоспособности Договором не покрываются.',
      'description.text15':
        'за вред, причиненный имуществу каждого Потерпевшего не более - 50 МРП.',
      'description.text8': 'Территория страхования: ',
      'description.text9': 'Республика Казахстан',
      'description.franchise.title': 'Франшиза (безусловная):',
      'description.franchise.text1':
        'за вред, причиненный имуществу пассажира устанавливается в размере 25 000 (двадцать пять тысяч) тенге по каждому и любому страховому случаю;',
      'description.franchise.text2':
        'за вред, причиненный жизни/здоровью пассажира франшиза не применяется, но применяется особое условие осуществления страховых выплат (первые 10 дней временной нетрудоспособности Договором не покрываются).',
      'description.text10': 'Тариф: ',
      'description.text11': 'от 0,25%',
      'description.text12':
        'Зачем заключать договор добровольного страхования гражданско-правовой ответственности перевозчика, осуществляющего перевозку пассажиров?',
      'description.li1':
        'Договор обязательного страхования ответственности перевозчика перед пассажирами не заключается с лицами, не имеющими разрешения уполномоченных органов на перевозку пассажиров, осуществляющих ее самостоятельно.',
      'description.li2':
        'Лимит ответственности по обязательному страхованию гражданско-правовой ответственности перевозчика перед пассажирами ограничен законодательством. Зачастую суммы выплат недостаточно и перевозчику приходится оплачивать часть ущерба за свой счет.',
      'description.li3':
        'Даже опытный водитель со стажем может допустить ошибку, которая приводит к ДТП.',
    },
  },
};

export default carrierLiabilityResources;
